import React, { useEffect, useState } from 'react';

/**
 * Componente Toast Profissional
 * 
 * Tipos disponíveis:
 * - success: verde (✓)
 * - error: vermelho (✕)
 * - warning: amarelo (⚠)
 * - info: azul (ℹ)
 */
const Toast = ({ message, type = 'info', duration = 3000, onClose, photo = null }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, 300);
  };

  if (!isVisible) return null;

  const getToastStyle = () => {
    const baseStyle = {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      minWidth: '300px',
      maxWidth: '450px',
      padding: '16px 20px',
      borderRadius: '12px',
      boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      zIndex: 10000,
      animation: isExiting ? 'toastSlideOut 0.3s ease-out forwards' : 'toastSlideIn 0.3s ease-out',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255,255,255,0.1)',
      cursor: 'pointer'
    };

    const typeStyles = {
      success: {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: '#fff'
      },
      error: {
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        color: '#fff'
      },
      warning: {
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: '#fff'
      },
      info: {
        background: 'linear-gradient(135deg, #003366 0%, #002244 100%)',
        color: '#fff'
      }
    };

    return { ...baseStyle, ...typeStyles[type] };
  };

  const getIcon = () => {
    const iconStyle = {
      width: '28px',
      height: '28px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      fontWeight: 'bold',
      flexShrink: 0,
      background: 'rgba(255,255,255,0.2)'
    };

    const icons = {
      success: '✓',
      error: '✕',
      warning: '⚠',
      info: 'ℹ'
    };

    return (
      <div style={iconStyle}>
        {icons[type]}
      </div>
    );
  };

  return (
    <>
      <style>
        {`
          @keyframes toastSlideIn {
            from {
              transform: translateX(120%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }

          @keyframes toastSlideOut {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(120%);
              opacity: 0;
            }
          }

          @media (max-width: 768px) {
            .professional-toast {
              left: 10px !important;
              right: 10px !important;
              min-width: auto !important;
              max-width: calc(100% - 20px) !important;
            }
          }
        `}
      </style>
      <div 
        className="professional-toast"
        style={getToastStyle()} 
        onClick={handleClose}
      >
        {photo ? (
          <div 
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundImage: `url(${photo})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              flexShrink: 0,
              border: '2px solid rgba(255,255,255,0.3)'
            }}
          />
        ) : (
          getIcon()
        )}
        <span style={{ 
          flex: 1, 
          fontSize: '15px',
          lineHeight: '1.5',
          fontWeight: '500'
        }}>
          {message}
        </span>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
          style={{
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: '#fff',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            lineHeight: '1',
            padding: 0,
            flexShrink: 0,
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}
          onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.2)'}
        >
          ×
        </button>
      </div>
    </>
  );
};

export default Toast;
